module.exports = import("https://esm.sh/spotify-url-info@3.2.18");;